import Model from '../utils/Model'
import CommonState from './CommonState'

export const False_Code = new CommonState(false, '否', 'yes')
export const True_Code = new CommonState(true, '是', 'no')

export const JUDGE_STATUS = [False_Code, True_Code]

export const ALL = new CommonState(0, '全部', 'All')
export const BUYING_BOXES = new CommonState(1, '买箱', 'Buying boxes')
export const SELLING_BOX = new CommonState(2, '卖箱', 'Selling box')
export const RENT_BOX = new CommonState(3, '租箱', 'Rent box')

export const ORDER_TYPE_LIST = [BUYING_BOXES, RENT_BOX, SELLING_BOX]

export const ORDER_TYPE_LISTS = [ALL, BUYING_BOXES, RENT_BOX]

export const AVAILABLE_NOW = new CommonState(1, '当前可用', 'Available now')
export const CURRENT_OCCUPANCY = new CommonState(2, '当前占用', 'Current occupancy')
export const ALREADY_SOLD = new CommonState(3, '已卖', 'Already sold')

export const CONTAINER_LIST = [ALL, AVAILABLE_NOW, CURRENT_OCCUPANCY, ALREADY_SOLD]

export const SOLD_OUT = new CommonState('1', '已卖出', 'Sold out')
export const OCCUPIED = new CommonState('2', '已占用', 'Occupied')

export function getOrderTypeByCode(code) {
  return Model.getObjByCode(code, ORDER_TYPE_LISTS)
}

export function getContainerByCode(code) {
  return Model.getObjByCode(code, CONTAINER_LIST)
}

export function orderTypeFunction(orderType) {
  if (orderType === 1) {
    return BUYING_BOXES.chineseName
  } else if (orderType === 2) {
    return SELLING_BOX.chineseName
  } else if (orderType === 3) {
    return RENT_BOX.chineseName
  }
  return ''
}
